import axios from 'axios';

import {
    IMPLANT_HISTORY_LIST_REQUEST,
    IMPLANT_HISTORY_LIST_SUCCESS,
    IMPLANT_HISTORY_LIST_FAIL,

    IMPLANT_HISTORY_DETAILS_REQUEST,
    IMPLANT_HISTORY_DETAILS_SUCCESS,
    IMPLANT_HISTORY_DETAILS_FAIL,

    IMPLANT_HISTORY_DELETE_REQUEST,
    IMPLANT_HISTORY_DELETE_SUCCESS,
    IMPLANT_HISTORY_DELETE_FAIL,

    IMPLANT_HISTORY_CREATE_REQUEST,
    IMPLANT_HISTORY_CREATE_SUCCESS,
    IMPLANT_HISTORY_CREATE_FAIL,

    IMPLANT_HISTORY_UPDATE_REQUEST,
    IMPLANT_HISTORY_UPDATE_SUCCESS,
    IMPLANT_HISTORY_UPDATE_FAIL,

    IMPLANT_HISTORY_REQUEST,
    IMPLANT_HISTORY_FAIL,
    IMPLANT_HISTORY_RESET,
    IMPLANT_HISTORY_SUCCESS,

    IMPLANT_HISTORY_COUNT_SUCCESS,
    IMPLANT_HISTORY_COUNT_REQUEST,
    IMPLANT_HISTORY_COUNT_FAIL,

    IMPLANT_HISTORY_LIST_BY_PATIENT_ID_REQUEST,
    IMPLANT_HISTORY_LIST_BY_PATIENT_ID_SUCCESS,
    IMPLANT_HISTORY_LIST_BY_PATIENT_ID_FAIL,

    SET_CURRENT_PAGE,
    

} from "../constants/implantHistoryConstants";

// use dispatch to dispatch the request and throw it into the reducer
export const listImplantHistories = (filter) => async (dispatch, getState) => {
    try {
        dispatch({ type: IMPLANT_HISTORY_LIST_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        let params = {};
        // get the filter
        if (filter) {
            params = filter;
        }

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            },
            params
        }
        const { data } = await axios.get('/api/v1/implantHistory/all', config);

        dispatch({
            type: IMPLANT_HISTORY_LIST_SUCCESS,
            payload: data
        });


    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            // Check if 'errors' object exists
            if (error.response.data.errors) {
                // Loop through 'errors' object and construct error message
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            }
            // Check if 'detail' field exists
            if (error.response.data.detail) {
                errorMessages.push(`Detail: ${error.response.data.detail} `);
            }
            // check if 'message' field exists
            if (error.response.data.message) {
                errorMessages.push(`Message: ${error.response.data.message} `);
            }
        } else {
            errorMessages.push(error.message);
        }

        dispatch({
            type: IMPLANT_HISTORY_LIST_FAIL,
            payload: errorMessages,
        });
    }
}

// get implantHistories by patientId (preferred method for robust lookup)
export const listImplantHistoriesByPatientNhsNumber = (patientId, filter) => async (dispatch, getState) => {
    try {
        dispatch({ type: IMPLANT_HISTORY_LIST_BY_PATIENT_ID_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        let params = {};
        // get the filter
        if (filter) {
            params = filter;
        }

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            },
            params
        }
        const { data } = await axios.get(`/api/v1/implantHistory/patient/${patientId}`, config);

        dispatch({
            type: IMPLANT_HISTORY_LIST_BY_PATIENT_ID_SUCCESS,
            payload: data
        });

    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            // Check if 'errors' object exists
            if (error.response.data.errors) {
                // Loop through 'errors' object and construct error message
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            } else if (error.response.data.message) {
                errorMessages.push(error.response.data.message);
            } else if (error.response.data.detail) {
                errorMessages.push(error.response.data.detail);
            } else {
                errorMessages.push(error.response.data);
            }
        } else {
            errorMessages.push(error.message);
        }

        dispatch({
            type: IMPLANT_HISTORY_LIST_BY_PATIENT_ID_FAIL,
            payload: errorMessages,
        });
    }
}



// count implantHistories
export const countImplantHistories = () => async (dispatch, getState) => {
    try {
      dispatch({ type: IMPLANT_HISTORY_COUNT_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
  
      const config = {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`
        },
      }
      const { data } = await axios.get('/api/v1/implantHistory/count', config);
  
      dispatch({
        type: IMPLANT_HISTORY_COUNT_SUCCESS,
        payload: data
      });
    } catch (error) {
      dispatch({
        type: IMPLANT_HISTORY_COUNT_FAIL,
        payload: error.response && error.response.data.detail
            ? error.response.data.detail
            : "Failed to fetch implantHistory counts",
      });
    }
  }
  


export const getImplantHistoryDetails = (_id) => async (dispatch, getState) => {
    try {
        dispatch({ type: IMPLANT_HISTORY_DETAILS_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.get(`/api/v1/implantHistory/${_id}`, config);

        dispatch({
            type: IMPLANT_HISTORY_DETAILS_SUCCESS,
            payload: data
        });

    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            // Check if 'errors' object exists
            if (error.response.data.errors) {
                // Loop through 'errors' object and construct error message
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            }
            // Check if 'detail' field exists
            if (error.response.data.detail) {
                errorMessages.push(`Detail: ${error.response.data.detail} `);
            }
            // check if 'message' field exists
            if (error.response.data.message) {
                errorMessages.push(`Message: ${error.response.data.message} `);
            }
        } else {
            errorMessages.push(error.message);
        }

        dispatch({
            type: IMPLANT_HISTORY_DETAILS_FAIL,
            payload: errorMessages,
        });
    }
}

export const deleteImplantHistory = (_id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: IMPLANT_HISTORY_DELETE_REQUEST
        })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await axios.delete(
            `/api/v1/implantHistory/${_id}/`,
            config
        )

        dispatch({
            type: IMPLANT_HISTORY_DELETE_SUCCESS,
        })


    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            // Check if 'errors' object exists
            if (error.response.data.errors) {
                // Loop through 'errors' object and construct error message
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            }
            // Check if 'detail' field exists
            if (error.response.data.detail) {
                errorMessages.push(`Detail: ${error.response.data.detail} `);
            }
            // check if 'message' field exists
            if (error.response.data.message) {
                errorMessages.push(`Message: ${error.response.data.message} `);
            }
        } else {
            errorMessages.push(error.message);
        }
        dispatch({
            type: IMPLANT_HISTORY_DELETE_FAIL,
            payload: errorMessages,
        })
    }
}

export const createImplantHistory = (changes) => async (dispatch, getState) => {
    try {
        dispatch({
            type: IMPLANT_HISTORY_CREATE_REQUEST
        })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const data = await axios.post(
            `/api/v1/implantHistory/`,
            changes,
            config
        )

        dispatch({
            type: IMPLANT_HISTORY_CREATE_SUCCESS,
            payload: data,
        })


    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            // Check if 'errors' object exists
            if (error.response.data.errors) {
                // Loop through 'errors' object and construct error message
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            }
            // Check if 'detail' field exists
            if (error.response.data.detail) {
                errorMessages.push(`Detail: ${error.response.data.detail} `);
            }
            // check if 'message' field exists
            if (error.response.data.message) {
                errorMessages.push(`Message: ${error.response.data.message} `);
            }
        } else {
            errorMessages.push(error.message);
        }

        dispatch({
            type: IMPLANT_HISTORY_CREATE_FAIL,
            payload: errorMessages,
        })
    }
}
const loadImplantHistoryBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const base64String = reader.result.split(',')[1];
            resolve(base64String);
        };
        reader.onerror = (error) => reject(error);
    });
};

// make implantHistory using a local implantHistory
export const makeImplantHistory = (file, implantHistoryId, apiEndPoint, apiKey) => async (dispatch, getState) => {

    const implantHistory = await loadImplantHistoryBase64(file);
    const implantHistory_input = JSON.stringify({ "implantHistory": implantHistory });
    const {
        userLogin: { userInfo },
    } = getState()

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userInfo.token}`
        }
    }

    const data = await axios.post(
        apiEndPoint,
        implantHistory_input,
        config
    )
    try {
        dispatch({
            type: IMPLANT_HISTORY_RESET
        })
        await axios({
            method: "POST",
            url: apiEndPoint,

            data: JSON.stringify({ "data": implantHistory }),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        }).then((response) => {
                dispatch({
                    type: IMPLANT_HISTORY_SUCCESS
                });
                if (implantHistoryId && response.data) {
                    dispatch(updateImplantHistory(implantHistoryId, { implantHistory: response.data }));
                }
            })
            .catch(function (error) {
                dispatch({
                    type: IMPLANT_HISTORY_FAIL
                });
                console.log(error.message);
            });
    }

    catch (error) {
        dispatch({
            type: IMPLANT_HISTORY_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }

}


export const updateImplantHistory = (_id, changes) => async (dispatch, getState) => {
    try {
        dispatch({
            type: IMPLANT_HISTORY_UPDATE_REQUEST
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        };

        const response = await axios.patch(
            `/api/v1/implantHistory/${_id}/`,
            changes,
            config
        );

        dispatch({
            type: IMPLANT_HISTORY_UPDATE_SUCCESS,
            payload: response.data, // Assuming the updated implantHistory data is returned
        });

        dispatch({
            type: IMPLANT_HISTORY_DETAILS_SUCCESS,
            payload: response.data, // Assuming the updated implantHistory data is returned
        });
    } catch (error) {
        let errorPayload = [];

        if (error.response && error.response.status === 400 && error.response.data.errors) {
            const validationErrors = error.response.data.errors;
            // Concatenate detailed validation errors to the error payload array
            errorPayload = Object.values(validationErrors).flat();
        }

        // Include generic error message or additional error data in the payload array
        if (error.response && error.response.data.detail) {
            errorPayload.push(error.response.data.detail);
        } else {
            errorPayload.push(error.message);
        }

        dispatch({
            type: IMPLANT_HISTORY_UPDATE_FAIL,
            payload: errorPayload,
        });
    }
};

